import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetUserSubscriptions = () => {
  const bilingService = useServices().billingService;
  return useQuery({
    queryKey: ['userSubscriptions'],
    queryFn: () => bilingService.getSubscriptions(),
    refetchOnWindowFocus: false
  });
};
